module.exports = require("react-webcam");